import React from 'react';

import { NoSearchResults } from 'components/search/results';
import { useGlobalSearchData } from 'lib/providers/GlobalSearchDataProvider';
import { useGlobalSearch } from 'lib/providers/GlobalSearchProvider';
import { SearchPageType } from 'lib/utils/global.search';

import styles from './OrganizationContentLayout.module.scss';

const OrganizationContentLayout: React.FC = ({ children }) => {
  const { type } = useGlobalSearch();
  const { noCommunities, noCompanies } = useGlobalSearchData();

  const noOrganizationResults = type === SearchPageType.COMMUNITIES ? noCommunities : noCompanies;

  return <section className={styles.container}>{noOrganizationResults ? <NoSearchResults /> : children}</section>;
};

OrganizationContentLayout.displayName = 'OrganizationContentLayout';

export default OrganizationContentLayout;
